
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-marketing",
      function () {
        return require("private-next-pages/referral-marketing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-marketing"])
      });
    }
  